// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_SectionAnswers from "../Ouroboros.Models.Brands.SectionAnswers/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var DocumentPromptAction = function (x) {
    return x;
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentPrompt (line 135, column 7 - line 137, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.contentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runUpdateSectionSuccess = function (env) {
    return function (documentId) {
        return function (updatedSection) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(env.updateSection)(updatedSection), runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRoute)(documentId)), runLoadingAction(env.loading.setSuccess) ]);
        };
    };
};
var runDocumentPromptAction = function (v) {
    return v;
};
var runAnswerSectionQuestions = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var readOption = function (v) {
    return v;
};
var mkDocumentPromptAction = DocumentPromptAction;
var missingDocumentOrSectionError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document or Section ID is missing"),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var handleSuccess = function (env) {
    return function (documentId) {
        return function (response) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runUpdateSectionSuccess(env)(documentId)(response.updated_section)));
        };
    };
};
var handleContentError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/document_prompt_controller.md";
var buildRequest = function (sectionId) {
    return function (response) {
        return {
            answers: Ouroboros_Models_Brands_SectionAnswers.makeSectionAnswers(response),
            section_id: sectionId
        };
    };
};
var runSubmissionTask = function (env) {
    return function (documentId) {
        return function (sectionId) {
            return function (response) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleSuccess(env)(documentId))(runAnswerSectionQuestions(env.answerSectionQuestions)(documentId)(buildRequest(sectionId)(response)));
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
            };
        };
    };
};
var submitPromptTask = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingDocumentOrSectionError)));
        })(function (document) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingDocumentOrSectionError)));
            })(function (sectionId) {
                return runSubmissionTask(env)(document.id)(sectionId)(response);
            })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.activeSection)));
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
    };
};
var mkDocumentPromptController = function (env) {
    return {
        submit: function (response) {
            return mkDocumentPromptAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitPromptTask(env)(response)));
        }
    };
};
export {
    DocumentPromptAction,
    mkDocumentPromptController,
    runDocumentPromptAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
